export default __webpack_public_path__ + "static/media/contact.8e7e0963.svg";